/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import "./styles.scss";
import { forwardRef } from "react";
import { uploadFile } from "../../../utilites/files";

const ImageInput = ({
  label,
  compulsory,
  style,
  inputStyle,
  className,
  onChange,
  setValue,
  innerWidth,
  files,
  photo,
  value,
  ...props
}) => {
  const uploadRef = useRef();
  const handleUpload = async ({ target: { files } }) => {
    // const updatedFile = new File([files[0]], `img-${Math.random().toString(16).slice(2)}`)
    uploadFile(files[0]).then((data) => {
      if (onChange) {
        onChange(data.location);
      }
    });
  };

  return (
    <div className="input-container" style={style}>
      {label && (
        <label style={{ display: "flex", width: "100%", fontSize: "1rem" }}>
          {label}{" "}
          {compulsory && (
            <span style={{ paddingLeft: "5px", color: "black" }}>*</span>
          )}
        </label>
      )}

      <div
        className={`prefix-input-container ${
          !props?.value ? "dotted" : ''
        } ${className}`}
        style={{
          width: innerWidth ? "98%" : "50%",
          justifyContent: "space-between",
          cursor: "pointer",
        }}
        onClick={() => {
          if (uploadRef) {
            if (!props.value) uploadRef.current.click();
          }
        }}
      >
        {(!value && !props.value) ? (
          <>
            {" "}
            <h3 style={{ marginLeft: "4%" }}>UPLOAD</h3>
            <div className="upload-icon" />
            <input
              ref={uploadRef}
              style={{ display: "none" }}
              type="file"
              accept={!files && "image/*"}
              onChange={handleUpload}
            />
          </>
        ) : (
          <>
            {value ?
            <h3 className={photo ? 'overflow' : ''} style={{padding:"0px 5px"}}>{value ? value?.split("/")[value?.split("/")?.length - 1]?.slice(0,20) : ''}</h3> : 
            <h3 style={{ marginLeft: "4%" }}>{props.value.split("/")[3].slice(0, 25)}</h3>}

            <div
              className="close-icon"
              style={{ marginRight: "4%" }}
              ref={uploadRef}
              onClick={() => {
                if (innerWidth && !photo) setValue("");
                else if (photo) setValue("coverPhoto", "");
                else setValue("logo", "");
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ImageInput;
